import { render, staticRenderFns } from "./overtimePay.vue?vue&type=template&id=52cffa56&scoped=true"
import script from "./overtimePay.vue?vue&type=script&lang=js"
export * from "./overtimePay.vue?vue&type=script&lang=js"
import style0 from "./overtimePay.vue?vue&type=style&index=0&id=52cffa56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cffa56",
  null
  
)

export default component.exports